var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.toggleView)?_c('AppDrawer'):_vm._e(),(_vm.toggleView)?_c('AppToolbar'):_vm._e(),_c('AppView'),_c('AppToasts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }